/* FERRY AUTO-GENERATED: DO NOT EDIT THIS FILE */ /* eslint-disable */ // @ts-nocheck
export var ShopLevel = {
  Low_Level_Shop: 1,
  Mid_Level_Shop: 2,
  High_Level_Shop: 3,
  Shop_Level_4: 4,
  Shop_Level_5: 5,
  Shop_Level_6: 6,
  Shop_Level_7: 7,
  Shop_Level_8: 8,
  Shop_Level_9: 9
};
export var GmvLevel = {
  GMV_0_Level: 0,
  GMV_0_2000_Level: 1,
  GMV_2000_50000_Level: 2,
  GMV_50000_Over_Level: 3
};
export var QuotaType = {
  Week: 1,
  Period: 2,
  Bonus: 3
};
export var CanNotConnectType = {
  SELLER_BLOCK: 1,
  CREATOR_BLOCK: 2,
  FAN_THRESHOLD: 3
};